export const MIN_REFRESH_TIME = 1000 * 60 * (3 / 60); //seconds

let cache = {
  entries: {
    base: {
      data: null,
      timestamp: null,
      status: null,
    },
  },
  get: function (key) {
    return this.entries[key];
  },
  set: function (key, value) {
    this.entries[key] = value;
  },
};

// Drop a cached entry so the next tryCache(key, …) always hits the network.
// Used when a real-time event tells us the underlying data changed before the
// MIN_REFRESH_TIME window has elapsed (e.g. a role-perms refresh).
export const invalidateCache = (key) => {
  delete cache.entries[key];
};

export const tryCache = async (key, func) => {
  let entry = cache.get(key);
  if (entry) {
    if (entry.status === 'fetching') {
      return new Promise((resolve, reject) => {
        const interval = setInterval(() => {
          let updatedEntry = cache.get(key);
          if (updatedEntry.status === 'success') {
            clearInterval(interval);
            resolve(updatedEntry.data);
          }
          if (updatedEntry.status === 'failed') {
            clearInterval(interval);
            reject(updatedEntry.reason);
          }
        }, 1000);
      });
    } else if (entry.timestamp && Date.now() - entry.timestamp < MIN_REFRESH_TIME) {
      return entry.data;
    }
  }
  cache.set(key, {
    ...key,
    status: 'fetching',
  });
  let data;

  try {
    data = await func();
  } catch (e) {
    cache.set(key, {
      status: 'failed',
      reason: e,
    });
    throw e;
  }

  cache.set(key, {
    data: data,
    timestamp: Date.now(),
    status: 'success',
  });
  return data;
};
